import angular from 'angular';

import Home from './home/home'
import Login from './login/login'
import ForgotPassword from './forgot_password'
import Settings from './settings'
// import Customer from './customer'
import Item from './item'
import Routes from './routes'
import Carrier from './carrier'
import Location from './location'
import Users from './users'
import Truck from './truck'
import Main from './main'
import Vault from './vault'
import Batch from './batch'
import Access_denied from './access_denied'
import RouteSheet from './routeSheet'
import Checkin from './checkin'
import Checkout from './checkout'
// import Contract from './contract'
import ShipmentBatch from './shipment_batch'
import RouteControl from './route_control'
import RouteThrow from './route_throw'
import Bagout from './bagout'
import CoinPullReport from './coin_pull_report'
import Holiday from './holiday'
import UserProfile from './user_profile'
import Branch from './branch'
// import Setup from './setup'
import Log from './log'
import BranchManagement from './branch_management'
import VaultClose from './vault_close'
import OrderPacking from './order_packing'
import BulkCashManagement from './bulk_cash_management'
import ATMCount from './atm_count'
import DepositPacking from './deposit_packing'
import VaultBalance from './vault_balance'
import BranchFundingSource from './branch_funding_source'
import ATMCodesManagement from './atm_codes_management'
// import FuelSurcharges from './fuel_surcharges'
// import Account from './account'
import ResetAtMCode from './reset_atm_code'
import RouteProgress from './route_progress'
// import SoftDeletedShipments from './soft_deleted_shipments'
import ServiceTickets from './service_tickets'
import ServiceSettings from './service_settings'
// import BillingCategory from './billing_category'
import VaultOperations from './vault_operations'
import RouteStats from './route_stats'
import BranchFundingSourceHoliday from './branch_funding_source_holiday'
import MasterCashSchedualeComponent from './master_cash_schedule'
import TNTBilling from './tnt_billing'
import TNTControl from './tnt_control'
import DeliveryRegionRouting from './delivery_region_routing'
import ServiceTicketParts from './service_ticket_parts'
import Verify2FACode from './verify_2FA_code'
import Reporting from './reporting'
import ItemType from './item_type'
import TNTReactApp from './tnt_react_app'
import OnDemandCall from './on_demand_call'
import PickupRequestManagement from './pickup_request_management';
import coinManagement from './coin_management'
import autoRouting from './auto_routing'
import CashActivity from './cash_activity'
import AchManagement from './ach_management'
import mileageReport from './branch_management/components/mileage_report'
import appEventLogs from './app_event_logs'
import preventativeMaintenance from './preventative_maintenance'

let componentModule = angular.module('app.components', [
        Main,
        Home,
        Login,
        ForgotPassword,
        RouteSheet,
        Settings,
        Batch,
        Branch,
        Vault,
        // Customer,
        // Contract,
        Item,
        Routes,
        Carrier,
        // Message,
        // Shiptype,
        Users,
        Location,
        Truck,
        Access_denied,
        Checkin,
        Checkout,
        ShipmentBatch,
        RouteControl,
        Bagout,
        CoinPullReport,
        Holiday,
        UserProfile,
        // Setup,
        Log,
        RouteThrow,
        BranchManagement,
        VaultClose,
        OrderPacking,
        BulkCashManagement,
        ATMCount,
        DepositPacking,
        VaultBalance,
        // Denomination,
        BranchFundingSource,
        ATMCodesManagement,
        // MobileApp,
        // FuelSurcharges,
        // Account,
        ResetAtMCode,
        RouteProgress,
        // SoftDeletedShipments,
        ServiceTickets,
        ServiceSettings,
        // BillableEvents,
        // BillingCategory,
        VaultOperations,
        RouteStats,
        BranchFundingSourceHoliday,
        MasterCashSchedualeComponent,
        TNTBilling,
        TNTControl,
        DeliveryRegionRouting,
        ServiceTicketParts,
        Verify2FACode,
        Reporting,
        ItemType,
        TNTReactApp,
        OnDemandCall,
        PickupRequestManagement,
        coinManagement,
        autoRouting,
        CashActivity,
        AchManagement,
        mileageReport,
        appEventLogs,
        preventativeMaintenance,
    ])

    .directive('hideZero', function() {
          return {
              link: function(scope, element) {
                  element.on('input change', function() {
                      if (this.value === '0') {
                          this.value = '';
                      }
                  })
              }
          };
      })

    .name;

export default componentModule;



// WEBPACK FOOTER //
// ./client/app/components/index.js